import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const getMyDrafts = (searchText, pageNumber, pageSize) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_CLASS_BY_STATUS(
      "Saved",
      searchText,
      pageNumber,
      pageSize
    ),
    "",
    cancelToken
  );
};

export default getMyDrafts;
